require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-kennetpostigo-lwt-node-starter.json") })
        }
      }, "path---package-unpublished-kennetpostigo-lwt-node-starter");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-kennetpostigo-lwt-node-starter!./.cache/json/package-unpublished-kennetpostigo-lwt-node-starter.json
// module id = 949
// module chunks = 231608221292675